import {Material, ShaderProperties} from './types';
import {vec3, vec4} from 'gl-matrix';
import * as WebGLUtils from "%COMMON/WebGLUtils";
import {ShaderLocationsVault} from "%COMMON/ShaderLocationsVault";


export const makeMaterial = (color: vec4, brightness: number, shininess: number): Material => {
    const scaled = color.map((n: number) => n * brightness);
    const scaledV3 = vec3.fromValues(scaled[0], scaled[1], scaled[2]);
    return {
        ambient: vec3.fromValues(brightness / 4, brightness / 4, brightness / 4),
        diffuse: scaledV3,
        specular: vec3.fromValues(1, 1, 1),
        shininess: shininess
    }
}

export const makeShader = (gl: WebGLRenderingContext, fShaderSrc: string, vShaderSrc: string, numLights: Number): ShaderProperties => {
    const shaderF = fShaderSrc.split('numLights').join(`${numLights}`);
    const shader = WebGLUtils.createShaderProgram(gl, vShaderSrc, shaderF);
    const locations = new ShaderLocationsVault(gl, shader);
    return {vShaderSrc, fShaderSrc, shader, locations};
}

/**
 * updates shader and shaderLocationsVault within a {@link ShaderProperties} obj
 * @param gl the {@link WebGLRenderingContext} to use
 * @param sProps the {@link ShaderProperties} object to modify
 * @param numLights the number of lights to set
 */
export const updateShaderProperties = (gl: WebGLRenderingContext, sProps: ShaderProperties, numLights: Number): ShaderProperties => {
    const {fShaderSrc, vShaderSrc, locations} = sProps;
    const shaderF = fShaderSrc.split('numLights').join(`${numLights}`);
    sProps.shader = WebGLUtils.createShaderProgram(gl, vShaderSrc, shaderF);
    sProps.locations = new ShaderLocationsVault(gl, sProps.shader);
    return sProps;
}